import { color } from '../common/color';

export const logo = {
  label: 'Logo & Header Style',
  name: 'logo',
  component: 'group',
  fields: [
    {
      label: 'Logo Image',
      name: 'image',
      component: 'image',
      description: 'Upload a custom logo image. Leave empty to use the default logo.',
    },
    {
      label: 'Logo Alt Text',
      name: 'alt',
      component: 'text',
      defaultValue: 'Brumate logo',
    },
    {
      label: 'Background Color',
      name: 'backgroundColor',
      component: 'color',
      colors: color.list,
      widget: 'block',
      description: 'Header background color',
      defaultValue: '#FFFFFF',
    },
    {
      label: 'Admin Links Color',
      name: 'adminLinksColor',
      component: 'color',
      colors: color.list,
      widget: 'block',
      description: 'Color for Rewards, Favorites, Search, Account, and Cart icons',
      defaultValue: '#000000',
    },
  ],
  defaultValue: {
    image: null,
    alt: 'Brumate logo',
    backgroundColor: '#FFFFFF',
    adminLinksColor: '#000000',
  },
};
